/* tslint:disable */
import {
  Machine,
  UserAccount
} from '../index';

declare var Object: any;
export interface MachineProgressInterface {
  "userAccountId": number;
  "machineId": number;
  "data"?: string;
  "sessionUuid"?: string;
  "createdAt": Date;
  "createdBy"?: number;
  "updatedAt": Date;
  "updatedBy"?: number;
  "completed"?: boolean;
  "moddingData"?: any;
  "completedLessons"?: boolean;
  "completedGoals"?: boolean;
  "completedNoChips"?: boolean;
  "totalTime"?: number;
  "timeToComplete"?: number;
  "skipped"?: boolean;
  "runTimeMs"?: number;
  "runStartTs"?: number;
  "runEndTs"?: number;
  "runScore"?: number;
  "id"?: number;
  machine?: Machine;
  user?: UserAccount;
}

export class MachineProgress implements MachineProgressInterface {
  "userAccountId": number;
  "machineId": number;
  "data": string;
  "sessionUuid": string;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "completed": boolean;
  "moddingData": any;
  "completedLessons": boolean;
  "completedGoals": boolean;
  "completedNoChips": boolean;
  "totalTime": number;
  "timeToComplete": number;
  "skipped": boolean;
  "runTimeMs": number;
  "runStartTs": number;
  "runEndTs": number;
  "runScore": number;
  "id": number;
  machine: Machine;
  user: UserAccount;
  constructor(data?: MachineProgressInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `MachineProgress`.
   */
  public static getModelName() {
    return "MachineProgress";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of MachineProgress for dynamic purposes.
  **/
  public static factory(data: MachineProgressInterface): MachineProgress{
    return new MachineProgress(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'MachineProgress',
      plural: 'MachineProgresses',
      path: 'MachineProgresses',
      idName: 'id',
      properties: {
        "userAccountId": {
          name: 'userAccountId',
          type: 'number'
        },
        "machineId": {
          name: 'machineId',
          type: 'number'
        },
        "data": {
          name: 'data',
          type: 'string'
        },
        "sessionUuid": {
          name: 'sessionUuid',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "completed": {
          name: 'completed',
          type: 'boolean',
          default: false
        },
        "moddingData": {
          name: 'moddingData',
          type: 'any'
        },
        "completedLessons": {
          name: 'completedLessons',
          type: 'boolean',
          default: false
        },
        "completedGoals": {
          name: 'completedGoals',
          type: 'boolean',
          default: false
        },
        "completedNoChips": {
          name: 'completedNoChips',
          type: 'boolean',
          default: false
        },
        "totalTime": {
          name: 'totalTime',
          type: 'number'
        },
        "timeToComplete": {
          name: 'timeToComplete',
          type: 'number'
        },
        "skipped": {
          name: 'skipped',
          type: 'boolean',
          default: false
        },
        "runTimeMs": {
          name: 'runTimeMs',
          type: 'number',
          default: 0
        },
        "runStartTs": {
          name: 'runStartTs',
          type: 'number',
          default: 0
        },
        "runEndTs": {
          name: 'runEndTs',
          type: 'number',
          default: 0
        },
        "runScore": {
          name: 'runScore',
          type: 'number',
          default: 0
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        machine: {
          name: 'machine',
          type: 'Machine',
          model: 'Machine',
          relationType: 'belongsTo',
                  keyFrom: 'machineId',
          keyTo: 'id'
        },
        user: {
          name: 'user',
          type: 'UserAccount',
          model: 'UserAccount',
          relationType: 'belongsTo',
                  keyFrom: 'userAccountId',
          keyTo: 'id'
        },
      }
    }
  }
}
